import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from "react-router-dom";
import WriteBox from "../../QuestionPage/WordBox";
import QuestionBox from "../../QuestionPage/questionbox";
import MCQMultiSelect from "../../QuestionPage/MultiOptionSelect";

// Fetching Data from the API]

// End

// Page Html
export default function MultipleTypeDoubleMockPage({ question, onInputChange ,questionNumber , maxQuestion }) {
  // End
  const navigate = useNavigate();

  const [selectedOptions, setSelectedOptions] = useState([]);
  const [isAttempted, setIsAttempted] = useState(false);
  const [submitted, setSubmitted] = useState(false);



  const handleButtonClick = () => {
    navigate("/");
  };

  const mockData = question;

  const [originalWords, setOriginalWords] = useState("");
  const [McqOptions, setMcqOptions] = useState("");
  const [Mcq_Question, setMcq_Question] = useState("");

  // const [originalWords, setOriginalWords] = useState("");

  // const originalWords = mockData.question;

  useEffect(() => {
    // Set the state when the question prop changes
    setOriginalWords(question.question);
    setMcqOptions(question.option);
    setMcq_Question(question.question_mcq);
  }, [question]);

  const handleSelectedOptionsChange = useCallback((selected) => {
    console.log("Selected options:", selected);
    setSelectedOptions(selected);
    onInputChange(selected);

  }, []);

  useEffect(() => {
    console.log("selectedOptions state updated:", selectedOptions);
  }, [selectedOptions]);
  return (
    <div>
      <div className="relative top-10 bg-gray-100 max-w-full py-5 px-5 md:px-10 mx-4 rounded-sm border border-t-2">
        <div className="max-w-full bg-blue-500 h-3"></div>
        <h3 className="text-lg  pt-3 font-bold text-gray-900 sm:text-2xl ml-1 text-center md:text-start">
          Mock Test
        </h3>
        <h2 className=" absolute  text-1xl font-bold right-10 top-10">
          {" "}
        </h2>
        <h2 className=" absolute  text-sm font-semibold text-gray-700 right-10 top-13">
          {" "}
        Question {questionNumber} of {maxQuestion}
        </h2>
        <p className="p-2">
        You will hear a sentence. Please repeat the sentence exactly as you hear it. You will hear the sentence only once.
        </p>

        <QuestionBox question={originalWords}/>
        {/* <div className="font-bold p-2 pt-4 ml-[1000px] ">Time left:9.22 </div> */}
        <MCQMultiSelect question={Mcq_Question} options={McqOptions}  onOptionSelect={handleSelectedOptionsChange}
/>


      </div>
    </div>
  );
}
